'use client';

import { Button } from '@shared/components/shadcn';
import { Verified } from '@shared/icons/system';
import { useTranslations } from 'next-intl';
import { useMultistepForm } from '../../../../../../form-controls/MultistepForm/hooks/useMultistepForm';
import type { StepProps } from '../../types/edit-mobile-number';

const ConfirmationStep = ({ namespace, onConfirmDone }: StepProps) => {
  const t = useTranslations(namespace);
  const { goToNextStep } = useMultistepForm();

  const handleDone = () => {
    if (onConfirmDone) {
      onConfirmDone();
      return;
    }
    void goToNextStep();
  };

  return (
    <div className="flex flex-col h-full" data-testid="success-changed">
      <div className="md:mt-6">
        <Verified size="extra-extra-large" className="mb-5" data-testid="verified-icon" />
        <h4 className="mb-8">{t('title')}</h4>
      </div>
      <div className="text-center mt-auto md:mt-8" data-track-container="Actions">
        <Button variant="primary" className="w-full" onClick={handleDone} data-track-name="Done" data-testid="success-done-button">
          {t('close')}
        </Button>
      </div>
    </div>
  );
};

export { ConfirmationStep };
